import {
  GET_SII_INFORMATION,
  GET_SII_INFORMATION_ERROR,
  GET_SII_INFORMATION_SUCCESS
} from './SiiInformationSection.actions'

const siiInformationState = {
  businessActivities: [],
  dni: '',
  error: undefined,
  loading: true
}

/**
 * The SII Information reducer.
 */
const siiInformationReducer = (state = siiInformationState, { payload, type }) => {
  switch (type) {
    case GET_SII_INFORMATION: {
      return { ...state, loading: true }
    }
    case GET_SII_INFORMATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        businessActivities: payload.businessActivities,
        dni: payload.dni
      }
    }
    case GET_SII_INFORMATION_ERROR: {
      return { ...state, loading: false, dni: payload.dni, error: payload.error }
    }
    default: {
      return state
    }
  }
}

export default siiInformationReducer
